import api from "@/api";

export default {
  namespaced: true,
  state: {
    jobTitles: [],
  },
  getters: {
    getJobTitles(state) {
      return state.jobTitles;
    },
  },
  mutations: {
    setJobTitles(state, data) {
      state.jobTitles = data || [];
    },
  },
  actions: {
    fetchAllJobTitles({ commit }) {
      return new Promise((resolve, reject) => {
        api()
          .get("/jobTitles/getAll", {
            headers: { Authorization: localStorage.getItem("JwtToken") },
          })
          .then((res) => {
            commit("setJobTitles", res.data.data);
            resolve(res);
          })
          .catch((err) => {
            commit("setJobTitles", []);
            reject(err);
          });
      });
    },
  },
};
